/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between a UUID and a ULID?`)
};

const es_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre un UUID y un ULID?`)
};

const de_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen einer UUID und einer ULID?`)
};

const nl_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen een UUID en een ULID?`)
};

const fr_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre un UUID et un ULID ?`)
};

const it_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra un UUID e un ULID?`)
};

const pt_br2_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um UUID e um ULID?`)
};

const pt_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre um UUID e um ULID?`)
};

const ja_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID と ULID の違いは何ですか?`)
};

const zh_ud_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID 和 ULID 有什么区别?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq4_q", locale)
	if (locale === "en") return en_ud_faq4_q(inputs)
	if (locale === "es") return es_ud_faq4_q(inputs)
	if (locale === "de") return de_ud_faq4_q(inputs)
	if (locale === "nl") return nl_ud_faq4_q(inputs)
	if (locale === "fr") return fr_ud_faq4_q(inputs)
	if (locale === "it") return it_ud_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq4_q(inputs)
	if (locale === "pt") return pt_ud_faq4_q(inputs)
	if (locale === "ja") return ja_ud_faq4_q(inputs)
	return zh_ud_faq4_q(inputs)
};